"use client"

import React, { useMemo } from "react"
import Link from "next/link"

import { AccountContext } from "@/lib/storefront/account/account-service"
import { cn } from "@/lib/utils"
import { Badge } from "@/components/ui/components"
import BasicCard from "@/components/common/BasicCard"
import { UbAccountDashboardViewStoryblok } from "@/components/storyblok/component-types"

interface AccountDashboardProfileCardProps {
  accountContext: AccountContext
  blok: UbAccountDashboardViewStoryblok
}

function determineInitials(accountContext: AccountContext) {
  const firstName = accountContext?.userData?.firstName ?? ""
  const lastName = accountContext?.userData?.lastName ?? ""

  if (firstName && lastName && firstName.length > 0 && lastName.length > 0) {
    return firstName.charAt(0).toUpperCase() + "." + lastName.charAt(0).toUpperCase() + "."
  } else {
    return ""
  }
}

function determineRoleString(accountContext: AccountContext) {
  if (accountContext?.roles && accountContext?.roles?.userRoles && accountContext?.roles?.userRoles.length > 0) {
    const roleNames = accountContext?.roles?.userRoles.map((role) => role.roleDisplayName)

    if (roleNames && roleNames.length > 0) {
      return roleNames.join(", ")
    }
  }

  return ""
}

export default function AccountDashboardProfileCard(props: AccountDashboardProfileCardProps) {
  const accountContext: AccountContext = props.accountContext
  const generalDiscount: number | undefined = 15 //accountContext?.userData?.generalDiscount //ToDO https://udobaer.atlassian.net/browse/UBW-964

  const roleString: string = useMemo(() => {
    return determineRoleString(props.accountContext)
  }, [props.accountContext])

  const initialsString: string = useMemo(() => {
    return determineInitials(props.accountContext)
  }, [props.accountContext])
  return (
    <>
      <BasicCard className={"text-sm"}>
        <div className={"flex w-full flex-row items-center justify-between gap-2"}>
          <h2 className={"text-lg font-bold"}>{props.blok.my_profile_headline}</h2>
          <Link className={"text-gray-400 underline text-sm"} prefetch={false} href={"/account/profile"}>
            {props.blok.got_to_profile_text}
          </Link>
        </div>
        <div className={"flex flex-row gap-2"}>
          <div className={"flex flex-col justify-start p-2"}>
            <div
              className={
                "flex size-16 items-center justify-center rounded-full bg-primary text-2xl font-bold text-white"
              }
            >
              <p>{initialsString}</p>
            </div>
          </div>
          <div className={"flex grow flex-col gap-1"}>
            <div className={"flex gap-2"}>
              <p>{accountContext.userData?.firstName}</p>
              <p>{accountContext.userData?.lastName}</p>
            </div>
            <p
              className={cn("text-primary hidden", {
                block: roleString && roleString.length > 0,
              })}
            >
              {roleString}
            </p>
            <p>{accountContext.customerData?.companyName}</p>

            <p>{accountContext.userData?.email}</p>

            {generalDiscount && generalDiscount > 0 && (
              <div className={"flex flex-row items-center justify-start gap-1"}>
                <p>{props.blok?.general_discount_text ?? ""}</p>
                <Badge className={"bg-primary text-white"}>{props.blok?.general_discount_active_text ?? "AKTIV"}</Badge>
              </div>
            )}

            {/*
            <pre>{JSON.stringify(accountContext, undefined, 1)}</pre>
*/}
          </div>
        </div>
      </BasicCard>
    </>
  )
}
